const SIZES = {
  sm: { img: "h-5 sm:h-6", sub: "text-[6px] sm:text-[7px]", gap: "mt-1", line: "w-4 sm:w-5" },
  hero: { img: "w-[80vw] md:w-[54vw] lg:w-[45vw] max-w-[880px] h-auto", sub: "text-[2.4vw] md:text-[1.15vw] lg:text-[0.95vw]", gap: "mt-3 md:mt-4", line: "w-[7vw] md:w-[4.5vw] lg:w-[3.5vw]" },
  footer: { img: "h-9", sub: "text-[8.5px]", gap: "mt-2", line: "w-7" },
};

export const LogoLockup = ({ light = false, size = "sm", align = "left", className = "" }) => {
  const s = SIZES[size];
  const rule = light ? "bg-[#F4EFE2]/70" : "bg-[#3E4831]/60";
  const ink = light ? "text-[#F4EFE2]" : "text-[#3E4831]";
  return (
    <div className={`inline-flex flex-col items-center ${ink} ${className}`}>
      <img
        src={light ? "/assets/wordmark-light.png" : "/assets/wordmark-dark.png"}
        alt="Vinedresser"
        className={`${s.img} select-none pointer-events-none`}
      />
      <div className={`flex items-center justify-center gap-3 ${s.gap}`}>
        <span className={`h-px ${s.line} ${rule}`} />
        <span className={`font-sans font-semibold uppercase whitespace-nowrap tracking-[0.42em] ${s.sub}`} style={{ marginRight: "-0.42em" }}>
          Vineyard Management
        </span>
        <span className={`h-px ${s.line} ${rule}`} />
      </div>
    </div>
  );
};
